export const RESOURCE_TYPES = Object.freeze([
  'unknown',
  'account',
  'project',
  'repository',
  'branch',
  'commit',
  'issue',
  'pull_request',
  'release',
  'deployment',
  'domain',
  'environment',
  'database',
  'storage',
  'api',
  'worker',
]);

export const PROVIDERS = Object.freeze([
  'omnianalytics',
  'github',
  'gitlab',
  'bitbucket',
  'vercel',
  'cloudflare',
  'firebase',
  'supabase',
  'neon',
  'postgresql',
  'manual',
]);

export const HEALTH_STATES = Object.freeze([
  'connected',
  'synchronizing',
  'healthy',
  'degraded',
  'expired',
  'disconnected',
  'error',
  'unknown',
]);

export const VERIFICATION_STATES = Object.freeze([
  'verified',
  'user_defined',
  'imported',
  'inferred',
  'unknown',
]);

export const SOURCE_LABELS = Object.freeze({
  github_api: 'GitHub API',
  gitlab_api: 'GitLab API',
  bitbucket_api: 'Bitbucket API',
  vercel_api: 'Vercel API',
  cloudflare_api: 'Cloudflare API',
  firebase_api: 'Firebase API',
  supabase_api: 'Supabase API',
  neon_api: 'Neon API',
  webhook: 'Webhook',
  oauth_integration: 'OAuth integration',
  manual_connection: 'Manual connection',
  imported_metadata: 'Imported metadata',
  repository_metadata: 'Repository metadata',
  package_metadata: 'Package metadata',
  inferred: 'Inferred',
  unknown: 'Unknown',
});

export const SAFE_METADATA_KEYS = Object.freeze([
  'accountName',
  'accountScope',
  'associatedProject',
  'author',
  'branch',
  'commit',
  'commitSha',
  'completedAt',
  'connectionStatus',
  'contributors',
  'count',
  'createdAt',
  'databaseType',
  'defaultBranch',
  'deploymentStatus',
  'description',
  'dnsProvider',
  'domain',
  'domains',
  'durationMs',
  'environment',
  'environmentConfigurationStatus',
  'evidence',
  'framework',
  'fullName',
  'hash',
  'host',
  'issueCount',
  'language',
  'lastChecked',
  'lastDeployment',
  'lastSynced',
  'latestCommit',
  'latestRelease',
  'organizations',
  'owner',
  'packageName',
  'permissions',
  'previewDeployments',
  'productionDeployment',
  'projectId',
  'pullRequestCount',
  'region',
  'repositoryCount',
  'runtime',
  'shortHash',
  'sslStatus',
  'startedAt',
  'state',
  'summary',
  'target',
  'verificationStatus',
  'version',
  'visibility',
  'zone',
]);

export const RESOURCE_LABELS = Object.freeze({
  unknown: 'Unknown resource',
  account: 'Account',
  project: 'Project',
  repository: 'Repository',
  branch: 'Branch',
  commit: 'Commit',
  issue: 'Issue',
  pull_request: 'Pull request',
  release: 'Release',
  deployment: 'Deployment',
  domain: 'Domain',
  environment: 'Environment',
  database: 'Database',
  storage: 'Storage',
  api: 'API',
  worker: 'Worker',
});

export const isKnownResourceType = (value) => RESOURCE_TYPES.includes(value);
export const isKnownHealthState = (value) => HEALTH_STATES.includes(value);
export const isKnownVerificationState = (value) => VERIFICATION_STATES.includes(value);
